import { render, staticRenderFns } from "./VerificationStatusButton.vue?vue&type=template&id=45a131b4&scoped=true&"
import script from "./VerificationStatusButton.vue?vue&type=script&lang=js&"
export * from "./VerificationStatusButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a131b4",
  null
  
)

export default component.exports